var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","small":"","depressed":"","href":_vm.downloadUrl,"target":"_blank"},domProps:{"textContent":_vm._s('Download')}})}
var staticRenderFns = []

export { render, staticRenderFns }